import React from 'react'
import { FormikProps, withFormik, Form } from 'formik'
import Input from '../../components/input'
import { useTranslation } from 'react-i18next'

interface ProfileProps {
  onSubmit: (values: ProfileValues) => void
  children?: React.ReactNode
  user: string
  name: string
}

interface ProfileValues {
  user: string
  name: string
}

const InnerForm: React.FunctionComponent<
  ProfileProps & FormikProps<ProfileValues>
> = ({ values, errors, handleChange, handleBlur, touched, children }) => {
  const { t } = useTranslation()

  return (
    <div className="">
      <span className="sub-title color-grey-dark">{`${t('PREFERENCES')}`}</span>
      <Form>
        <Input
          id="name"
          label={`${t('DISPLAY_NAME')}`}
          type="text"
          value={values.name}
          onChange={handleChange}
          touched={touched.name}
          classNameInput="input"
          classNameLabel="color-primary"
          required={true}
          className="col-12 col-md-6"
        />

        <div className="container-buttton-profile">
          <button className="button-first width-200" type="submit">
            {`${t('UPDATE')}`}
          </button>
        </div>
      </Form>
    </div>
  )
}

const ProfileForm = withFormik<ProfileProps, ProfileValues>({
  mapPropsToValues: (props) => {
    const initialValues: ProfileValues = {
      user: props.user,
      name: props.name,
    }
    return { ...initialValues, ...props }
  },

  handleSubmit(values: ProfileValues, { props }) {
    props.onSubmit(values)
  },
})(InnerForm)
export default ProfileForm
